<template>
  <v-btn x-small @click="refresh" outlined>
    <v-icon small>mdi-refresh</v-icon>
  </v-btn>
</template>

<script>
import { createWidgetMixin } from 'vue-instantsearch';
const connectRefresh = (
  renderFn,
  unmountFn
) => (/* this widget has no parameters */) => ({
  init() {
    renderFn({ refresh: () => {} }, true);
  },
  mounted() {
    this.refresh()
  },
  render({ instantSearchInstance }) {
    const refresh = instantSearchInstance.refresh.bind(instantSearchInstance);
    renderFn({ refresh }, false);
  },
  dispose() {
    unmountFn();
  },
});
export default {
  mixins: [createWidgetMixin({ connector: connectRefresh })],
  methods: {
    refresh() {
      this.state.refresh();
    },
  },
};
</script>